// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-hero_wrapper__bjQX2","image-box":"image-hero_image-box__wM0Cn"};